<template>
  <p v-if="message" class="error">
    <span>Error: {{ message }}</span>
  </p>
</template>

<script>
export default {
  props: ["message"]
}
</script>

<style lang="scss" scoped>
.error {
  margin: 20px 0;
  text-align: center;

  span {
    display: inline-block;
    padding: 15px;
    color: #d94848;
    background: #fff3f3;
    border: 0.1rem solid #d94848;
    border-radius: 4px;
  }
}
</style>
